import { useContext, useEffect, useReducer, useState } from "react";
import "../CalculatorForm/CalculatorForm.css";
import { GROSS_MARGIN_MESSAGE } from "../../api/constants";
import { AppContext } from "../../context/calculatorFormContext";
import { manualFormReducer } from "../../reducers/ActionHandlers/ManualFormActionHandler";
import { manualFormInitialState } from "../../reducers/InitialStates/ManualFormInitialState";
import Loader from "../Loader";
import { KpiForm } from "./KpiForm/KpiForm";
import { fetchDropDownData, setUom } from "./KpiForm/KpiFormFunctions";
import { KpiFormMessage } from "./KpiFormMessage";
import { ManualFormButtons } from "./ManualFormButtons";
import UserAction from "./UserAction";
import { WarningMessage } from "./WarningMessage";
import CustomLabel from "./customLabel";

const ManualEntryFormContent = (props: { isAccordionOpen: boolean }) => {
  const { dispatch, state } = useContext(AppContext);
  const [myState, myDispatch] = useReducer(manualFormReducer, manualFormInitialState);
  const [country, setCountry] = useState<string>("");
  const { isAccordionOpen } = props;

  useEffect(() => {
    void fetchDropDownData(myDispatch);
  }, []);

  // on page load,set the uom value as MWh else set as per condition
  useEffect(() => {
    setUom(state.business, state.commodity, state.evp, myDispatch, dispatch);
  }, [state.business, state.commodity, myDispatch, dispatch]);
  return (
    <>
      <UserAction />
      {isAccordionOpen && (
        <>
          <WarningMessage showMessage={myState.isWarningMsgAvailable} myDispatch={myDispatch} />
          <Loader isLoading={myState.isLoading} message={"Fetching Form Options"} />
          <KpiForm
            setCountry={setCountry}
            myState={myState}
            myDispatch={myDispatch}
            country={country}
            isAccordionOpen={isAccordionOpen}
          />
          {(() => {
            const normalizeEvpName = (evpName: string): string =>
              evpName.toLowerCase().replace(/[^a-z0-9]/g, "");
            return normalizeEvpName(state.evp) !== "tsproducts";
          })() && <KpiFormMessage />}
          <div className="align-btns-right">
            <div>
              {(() => {
                const normalizeEvpName = (evpName: string): string =>
                  evpName.toLowerCase().replace(/[^a-z0-9]/g, "");
                return normalizeEvpName(state.evp) === "tsproducts";
              })() && (
                <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                  <span style={{ fontStyle: "italic", color: "#666" }}>{GROSS_MARGIN_MESSAGE}</span>
                </div>
              )}
              <CustomLabel />
            </div>
            <ManualFormButtons country={country} myState={myState} myDispatch={myDispatch} />
          </div>
        </>
      )}
    </>
  );
};

export default ManualEntryFormContent;
